import { createContext } from 'react'

const BlacklistContext = createContext()

export default BlacklistContext
